/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-clock': {
    width: 14,
    height: 14,
    viewBox: '0 0 24 24',
    data: '<path d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"/>'
  }
})
